import {Component, Input, OnInit} from '@angular/core';
import {StatnaSkuska} from '../model/statnaSkuska';
import {AppService} from '../app.service';
import { HttpClient } from '@angular/common/http';
import {TranslateService} from '@ngx-translate/core';
import {DatePipe} from '@angular/common';

@Component({
    selector: 'app-statna-skuska',
    templateUrl: './statna-skuska.component.html',
    styleUrls: ['./statna-skuska.component.css'],
    standalone: false
})
export class StatnaSkuskaComponent implements OnInit {

  @Input()
  statnaSkuska: StatnaSkuska;
  loading = false;

  constructor(
    private appService: AppService,
    private http: HttpClient,
    private translate: TranslateService
  ) { }

  ngOnInit() {
  }

  zrusitZiadostUznanie() {
    this.appService.openConfirmDialog(this.translate.instant('Zrušiť žiadosť uznania?'))
      .subscribe(res => {
        if (res === 'OK') {
          this.http.get(
            '/ais/rest/portal/statne-skusky/ziadost-zrusit',
            {params: {id: this.statnaSkuska.idPrihlaska.toString()}}
          ).subscribe(() => {
            this.appService.fetchStudia(true);
            this.appService.openOkDialog('Žiadosť zrušená.');
          });
        }
      });
  }

  zaevidovatZiadostUznanie() {
    this.appService.openConfirmDialog(this.translate.instant('Zaevidovať žiadosť uznania?'))
      .subscribe(res => {
        if (res === 'OK') {
          this.http.get(
            '/ais/rest/portal/statne-skusky/ziadost-zaevidovat',
            {params: {id: this.statnaSkuska.idPrihlaska.toString()}}
          ).subscribe(() => {
            this.appService.fetchStudia(true);
            this.appService.openOkDialog('Žiadosť zaevidovaná.');
          });
        }
      });
  }

  otazkyPredmetuVyjadrenieKomisie() {
    this.appService.openPortalAppWindow(
      'ais.gui.vs.es.VSES208_OtazkyPredmetuStatnejSkuskyDlg',
      this.statnaSkuska.idPrihlaska
    );
  }

  obsahovaNaplnPredmetu() {
    const url = '/ais/rest/portal/statne-skusky/obsahova-napln/' + this.statnaSkuska.idPrihlaska + '/lng/SK';
    const top  = (screen.height / 2) - 300;
    const left = (screen.width / 2) - 350;

    this.loading = true;

    this.http.post(url, null, { responseType: 'text' }).subscribe((data) => {
      const win = window.open(
        '',
        'Title',
        'toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,' +
        'resizable=yes,width=700,height=600,top=' + top + ',left=' + left
      );
      win.document.body.innerHTML = data;
      this.loading = false;
    });
  }

  nastavitPreferovanyDen() {
    this.appService.openPortalAppWindow(
      'ais.gui.vs.es.VSES294_NastavitDatumDlg',
      this.statnaSkuska.idPrihlaska
    );
  }

  odhlasitTermin() {
    this.appService.openConfirmDialog(this.translate.instant('Odhlásiť z termínu?'))
      .subscribe(res => {
        if (res === 'OK') {
          this.http.delete(
            '/ais/rest/portal/studium/statneskusky',
            {
              responseType: 'text',
              params: {id: this.statnaSkuska.idPrihlaska.toString()}
            }).subscribe(
            () => {
                this.appService.openOkDialog('Odhlásenie prebehlo úspešne.');
                this.appService.fetchStudia(true);
              },
            (err) => {
                this.appService.openErrorDialog(JSON.parse(err.error).message);
            }
          );
        }
      });
  }

  getPrihlasovanie(ss: StatnaSkuska) {
    let out = '';

    if (ss.prihlasovanieOd) {
      out += (new DatePipe('sk_SK')).transform(ss.prihlasovanieOd);
    }

    if (ss.prihlasovanieDo === null) {
      return this.translate.instant('od') + ' ' + out;
    }

    if (ss.prihlasovanieDo) {
      out += ' - ' + (new DatePipe('sk_SK')).transform(ss.prihlasovanieDo);
    }

    return out;
  }

  getOdhlasovanie(ss: StatnaSkuska) {
    let out = '';

    if (ss.odhlasovanieOd) {
      out += (new DatePipe('sk_SK')).transform(ss.odhlasovanieOd);
    }

    if (ss.odhlasovanieDo === null) {
      return this.translate.instant('od') + ' ' + out;
    }

    if (ss.odhlasovanieDo) {
      out += ' - ' + (new DatePipe('sk_SK')).transform(ss.odhlasovanieDo);
    }

    return out;
  }
}
